import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './custom-modal.scss';

const CustomModal = ({setShow, show, children,title="",style={},maxWidth="xl"}) => {
  return (
    <Dialog
      open={show}
      onClose={() => setShow(false)}
      maxWidth={maxWidth}
      fullWidth
      // className="custom-width-modal"
      PaperProps={{
        sx: {
          maxWidth: '95vw',
          width: '100%',
          minWidth: '300px',
          ...style
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span style={{fontSize: "1.5rem", fontWeight: "bold"}}>{title}</span>
          <IconButton 
            onClick={() => setShow(false)}
            size="small"
            sx={{ ml: 'auto' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
